import { BrowserRouter as Router } from "react-router-dom";
import Main from "./components/Main";

const App = () => {
  return (
    <Router>
      <Main />
    </Router>
  );
};

export default App;
